import dayjs from 'dayjs';

export const formatShortDateTime = (date: string) => {
  return dayjs(date).format('DD MMM  HH:mm');
};
